// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wEYOHj7dQOITMo7Rslyu{justify-content:center;align-items:center;gap:8px;display:flex}.wEYOHj7dQOITMo7Rslyu .h26vDhd6dUocSuWibTPl{border:1px solid var(--action-outlined-tertiary-border);background:var(--background-primary-inverted-primary);border-radius:4px;width:-webkit-max-content;width:max-content;padding:2px}.bqjXB5206wAeJbyPc_Az{width:100%}.bU6ijS5b44RMQEGn4Tyj>div{justify-content:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customTitleWrapper": `wEYOHj7dQOITMo7Rslyu`,
	"icon": `h26vDhd6dUocSuWibTPl`,
	"alert": `bqjXB5206wAeJbyPc_Az`,
	"header--collapse": `bU6ijS5b44RMQEGn4Tyj`,
	"headerCollapse": `bU6ijS5b44RMQEGn4Tyj`
};
export default ___CSS_LOADER_EXPORT___;
